export interface QueueFormState {
    name: string;
    strategy: string;
    fileAudio: string;
    isActive: boolean;
    users: number[];
}
